export const SITE_NAME = 'Safe Haven Wellness Group'

export const OG_IMAGE_PATH = '/images/safe_haven_logo_clear.png'
export const OG_IMAGE_WIDTH = 2000
export const OG_IMAGE_HEIGHT = 2000
export const OG_IMAGE_TYPE = 'image/png'

export function buildOrganizationJsonLd(siteOrigin, logoUrl) {
  if (!siteOrigin || !logoUrl) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: siteOrigin,
    logo: {
      '@type': 'ImageObject',
      url: logoUrl,
      width: OG_IMAGE_WIDTH,
      height: OG_IMAGE_HEIGHT
    }
  }
}

const BUILD_SITE_URL = (process.env.VUE_APP_SITE_URL || '').replace(/\/$/, '')

export function getSiteOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }
  return BUILD_SITE_URL
}

export function getAbsoluteUrl(path) {
  const origin = getSiteOrigin()
  if (!origin) return path
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`
}

export function getOgImageUrl() {
  return getAbsoluteUrl(OG_IMAGE_PATH)
}
